package org.example.project.enginechat

import androidx.compose.runtime.Composable
import org.example.project.utils.All

@Composable
fun ChatModuleScreen(
    popupMode: Boolean = false,
    onClose: (() -> Unit)? = null,
    embeddedInEngine: Boolean = false,
    conversationOnly: Boolean = false,
    presetUser: All? = null,
    contactCompanyFilterId: String = ""
) {
    ChatEngineLayout(
        popupMode = popupMode,
        onClose = onClose,
        embeddedInEngine = embeddedInEngine,
        conversationOnly = conversationOnly,
        presetUser = presetUser,
        contactCompanyFilterId = contactCompanyFilterId
    )
}
